module.exports = __webpack_public_path__ + "static/media/visa.b44058b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/payment-systems/visa.png
// module id = 534
// module chunks = 0